import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useCloseOnEscape } from '../../../hooks/useCloseOnEscape';
import CloseButton from './CloseButton';
import { ReactComponent as OccasiaLogoIcon } from '../../icons/occasia-logo-icon.svg';
import '../../Landing2Header/Landing2Header.css';
import './ModalWrapper.css';

const PAGE_HEADER_CLASSES = ['auth-modal-login', 'auth-modal-signup'];

const ModalWrapper = ({ isOpen, onClose, children, className = '' }) => {
  useCloseOnEscape(isOpen, onClose);
  const showPageHeader = PAGE_HEADER_CLASSES.some((token) =>
    className.split(/\s+/).includes(token)
  );

  useEffect(() => {
    if (!isOpen) return undefined;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="auth-modal-overlay" onClick={handleOverlayClick}>
      <div className={`auth-modal ${className}`} onClick={(e) => e.stopPropagation()}>
        {showPageHeader ? (
          <div className="auth-modal-page-header">
            <nav className="l2-header-nav">
              <Link to="/" className="l2-header-logo" aria-label="Occasia" onClick={onClose}>
                <OccasiaLogoIcon className="l2-header-logo-svg" />
              </Link>
              <CloseButton className="auth-modal-page-close" onClick={onClose} />
            </nav>
          </div>
        ) : (
          <CloseButton
            className="auth-modal-close"
            onClick={onClose}
          />
        )}
        {children}
      </div>
    </div>
  );
};

export default ModalWrapper;
